import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { LixaniFiles } from 'lixani-lib-graphql';

import { makeStyles } from '@material-ui/core/styles';
import Icon from '@mdi/react';
import { mdiPencil, mdiPlus } from '@mdi/js';
import { Diversify } from 'mdi-material-ui';

const useStyles = makeStyles(() => ({
  imageContainer: {
    width: '100%',
  },
  image: {
    width: '100%',
    aspectRatio: 1,
    objectFit: 'cover',
    borderRadius: '50%',
  },
  emptyImage: {
    width: '100%',
    aspectRatio: 1,
    objectFit: 'cover',
    borderRadius: '50%',
    backgroundColor: 'black',
  },
}));

function ProjectImage(props) {
  const { className, fileObject, imageUpdated, requestFile } = props;
  const [src, setSrc] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    if (fileObject && !imageUpdated) {
      requestFile(fileObject.key)
        .then((url) => {
          if (url) {
            setSrc(url);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [fileObject]);

  return (
    <div className={classes.imageContainer}>
      {src && !imageUpdated ? (
        <img src={src} alt="" className={classes.image} />
      ) : imageUpdated && fileObject ? (
        <img
          src={URL.createObjectURL(fileObject)}
          alt=""
          className={classes.image}
        />
      ) : (
        <div className={classes.emptyImage} />
      )}
    </div>
  );
}

ProjectImage.propTypes = {
  className: PropTypes.string,
  fileObject: PropTypes.object,
  imageUpdated: PropTypes.bool,
  requestFile: PropTypes.func.isRequired,
};

export default LixaniFiles(ProjectImage);
